"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Loop = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Loop_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.578 6.874c-.68-2.709-2.947-4.66-5.579-4.66-1.916 0-3.629 1.026-4.688 2.633a.5.5 0 0 1-.835-.55c1.223-1.855 3.233-3.083 5.523-3.083 3.24 0 5.9 2.44 6.604 5.66h.97c.2 0 .352.092.407.257.05.152.003.326-.096.474v.002l-1.248 1.82c-.125.185-.3.29-.489.287-.188-.003-.36-.111-.483-.285l-.001-.002-1.265-1.819a.522.522 0 0 1-.087-.474c.059-.162.212-.26.414-.26h.853ZM3.275 9.126h-.853c.68 2.709 2.947 4.66 5.579 4.66 1.916 0 3.629-1.026 4.688-2.633a.5.5 0 1 1 .835.55c-1.223 1.855-3.233 3.083-5.523 3.083-3.24 0-5.9-2.44-6.604-5.66h-.97c-.2 0-.352-.092-.407-.257-.05-.152-.003-.326.096-.474v-.002l1.248-1.82c.125-.185.3-.29.489-.287.188.003.36.111.483.285l.001.002 1.265 1.819a.522.522 0 0 1 .087.474c-.059.162-.212.26-.414.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Loop_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Loop;
exports["default"] = _default;